import { useState } from 'react';
import { motion } from 'framer-motion';
import { PLATES } from './data';

export default function Archive() {
  const cats = ['All', ...new Set(PLATES.map(p => p.cat))];
  const [c, setC] = useState('All');
  const list = c === 'All' ? PLATES : PLATES.filter(p => p.cat === c);
  return (
    <div className="bg-[#050505] text-[#F8F4ED] min-h-screen">
      <section className="pt-32 pb-8 max-w-[1500px] mx-auto px-8 lg:px-14 border-b-[3px] border-[#F8F4ED]">
        <p className="font-mono text-[10px] tracking-[0.4em] uppercase text-[#A33A3A] mb-3">— /01 / Archive · 47 plates published</p>
        <h1 className="font-serif italic text-[44px] lg:text-[88px] leading-[0.95]">The archive.</h1>
      </section>
      <div className="border-b border-[#F8F4ED]/15 sticky top-20 bg-[#050505]/95 backdrop-blur-md z-30">
        <div className="max-w-[1500px] mx-auto px-8 lg:px-14 py-4 flex flex-wrap gap-2 font-mono text-[10px] tracking-[0.22em] uppercase">
          {cats.map(cat => (
            <button key={cat} onClick={() => setC(cat)} data-testid={`mh-cat-${cat}`} className={`px-4 py-1.5 transition-colors ${c === cat ? 'bg-[#A33A3A] text-[#F8F4ED]' : 'border border-[#F8F4ED]/25 text-[#F8F4ED]/65 hover:border-[#A33A3A]'}`}>{cat}</button>
          ))}
        </div>
      </div>
      <section className="max-w-[1500px] mx-auto px-8 lg:px-14 py-12 grid md:grid-cols-2 gap-x-6 gap-y-12">
        {list.map((p, i) => (
          <motion.article key={p.p} initial={{ opacity: 0 }} whileInView={{ opacity: 1 }} viewport={{ once: true }} transition={{ delay: (i % 4) * 0.04 }} className="group">
            <div className={`overflow-hidden ${i % 2 ? 'aspect-[4/5]' : 'aspect-[5/4]'}`}>
              <img src={p.img} alt="" className="w-full h-full object-cover group-hover:scale-[1.03] transition-transform duration-1000" loading="lazy" />
            </div>
            <div className="grid grid-cols-[80px_1fr_auto] gap-4 mt-4 border-b border-[#F8F4ED]/15 pb-4">
              <p className="font-mono text-[10px] tracking-[0.3em] uppercase text-[#A33A3A]">/{p.p}</p>
              <p className="font-serif italic text-xl text-[#F8F4ED]">{p.t}</p>
              <p className="font-mono text-[10px] tracking-[0.22em] uppercase text-[#F8F4ED]/55 whitespace-nowrap">{p.loc}</p>
            </div>
          </motion.article>
        ))}
      </section>
    </div>
  );
}
